import React from 'react';
import { boardSize as tooltip } from 'pu-data/Tooltips';
import Label from './base/Label';
import Tooltip from './base/Tooltip';
import PropTypes from 'prop-types'

import BoardLength from './BoardLength';
import BoardWidth from './BoardWidth';

const BoardSize = props => (
  <div className="form-group clearfix">
    <Label label={props.label} required={props.required} />
    {' '}
    <Tooltip id="tooltip-pcb-size" title={props.tooltip} />
    <div className="form-inline quote-size">
      <div className="size-wrapper">
        <BoardLength
          {...props}
          label={props.labelLength}
          required={false}
          tooltip={props.tooltipLength} 
          error={props.errorBoardLength} />
      </div>
      <div className="size-wrapper">
        <BoardWidth
          {...props}
          label={props.labelWidth}
          required={false}
          tooltip={props.tooltipWidth}
          error={props.errorBoardWidth} />
      </div>
    </div>
  </div>
);

BoardSize.defaultProps = {
  groupName: 'parameters',
  required: true,
  label: 'Board Size (in.)',
  labelLength: null,
  labelWidth: null,
  tooltip,
  tooltipLength: null,
  tooltipWidth: null,
};

BoardSize.propTypes = {
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
}

export default BoardSize;
